import React, { Suspense } from 'react';
import Spinner from '../../components/spinner';

// Lazy-loaded components
const SchoolReadinessProgramPageSession = React.lazy(() => import('../programs/schoolreadinessprogram/SchoolReadinessProgramSession'));
const SchoolReadinessProgramPageHeader = React.lazy(() => import('../programs/schoolreadinessprogram/SchoolReadinessProgramHeader'));

function SchoolReadinessProgramPage() {
  return (
    <div className="page-wrapper">
   
      {/* Suspense to handle lazy loading */}
      <Suspense fallback={<Spinner />}>
       <SchoolReadinessProgramPageHeader />
       <SchoolReadinessProgramPageSession />
      </Suspense>
    </div>
  );
}

export default SchoolReadinessProgramPage;
